<template>

  <section class="bulk-delete-overview">

    <div class="bulk-delete-overview__indicators">

      <div
        v-for="stat in stats"
        :key="stat.key"
        class="bulk-delete-overview__indicator"
        :class="`bulk-delete-overview__indicator--${stat.tone}`"
      >
         <span class="bulk-delete-overview__indicator-label">{{ stat.label }}</span
        > <strong class="bulk-delete-overview__indicator-value">{{ stat.value }}</strong
        >
      </div>

    </div>

  </section>

</template>

<script>
  export default {
    name: 'BulkDeleteOverview',
    props: {
      stats: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style scoped>
  .bulk-delete-overview {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    padding: 0.9rem 1rem;
    border: 1px solid #dde5f1;
    border-radius: 12px;
    background: #f8fafc;
  }

  .bulk-delete-overview__indicators {
    display: grid;
    grid-template-columns: repeat(3, minmax(88px, 1fr));
    gap: 0.65rem;
    width: 100%;
  }

  .bulk-delete-overview__indicator {
    padding: 0.65rem 0.8rem;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #fff;
  }

  .bulk-delete-overview__indicator--neutral {
    background: #f3f5f8;
    border-color: #e1e7ef;
  }

  .bulk-delete-overview__indicator--success {
    background: #f3fbf7;
    border-color: #cfe9db;
  }

  .bulk-delete-overview__indicator--warning {
    background: #fffaf0;
    border-color: #f0d9a0;
  }

  .bulk-delete-overview__indicator--muted {
    background: #f3f5f8;
    border-color: #e1e7ef;
  }

  .bulk-delete-overview__indicator--danger {
    background: #fff4f4;
    border-color: #f0d0d0;
  }

  .bulk-delete-overview__indicator-label {
    display: block;
    color: #748093;
    font-size: 0.73rem;
    font-weight: 600;
    line-height: 1.35;
  }

  .bulk-delete-overview__indicator-value {
    display: block;
    margin-top: 0.22rem;
    color: #1f2a3d;
    font-size: 1rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  @media (max-width: 575.98px) {
    .bulk-delete-overview {
      flex-direction: column;
      align-items: stretch;
    }

    .bulk-delete-overview__indicators {
      grid-template-columns: 1fr;
    }
  }
</style>
